import { defineMessages } from "react-intl";

import { useSortableListInputContext } from ".";
import { useFormatMessage } from "../../Intl/Context";
import Modal from "../../Modals/Modal";
import SortableListOptionsListOption from "./SortableListOptionsListOption";
import Button from "../../Buttons/Button";

const SortableListOptionsListModal = props => {
  const { hideModal } = props;
  const { inputOptions, label, maximumOptions } = useSortableListInputContext();

  // Options must all keep the same width when some of them display a description button
  const hasOptionsWithDescription = inputOptions.some(({ description }) => description);

  const t = useFormatMessage();
  const title = t(intlMessages.title);
  const selectItemsDescription = t(intlMessages.selectItemsDescription, {
    p: message => `<p>${message}</p>`
  });
  const maximumOptionsHint =
    maximumOptions && t(intlMessages.maximumOptionsHint, { count: maximumOptions });
  const validate = t(intlMessages.validate);

  return (
    <Modal
      isOpen
      shouldCloseOnOverlayClick
      onRequestClose={hideModal}
      title={title}
      className="modal-with-actions"
    >
      <div className="box padding-md margin-bottom-xs">
        <div
          className="form-text margin-top-none margin-bottom-sm"
          dangerouslySetInnerHTML={{ __html: selectItemsDescription }}
        />

        <span className="form-label">{label}</span>

        {maximumOptionsHint && <span className="form-text">{maximumOptionsHint}</span>}

        <div className="sortable-list-options-list">
          {inputOptions.map(option => (
            <SortableListOptionsListOption
              key={option.id}
              option={option}
              reserveDescriptionButtonSpace={hasOptionsWithDescription}
            />
          ))}
        </div>
      </div>

      <div className="modal-actions modal-buttons-container">
        <Button
          type="button"
          onClick={hideModal}
          className="btn btn-primary btn-block-md box-shadow-lg modal-action"
          label={validate}
          iconClassName="icon-validate"
          iconPosition="after"
        />
      </div>
    </Modal>
  );
};

export default SortableListOptionsListModal;

const intlMessages = defineMessages({
  title: {
    id: "inputs.sortableList.optionsListModal.title",
    defaultMessage: "Choisissez les options à prioriser"
  },
  selectItemsDescription: {
    id: "inputs.sortableList.optionsListModal.selectItemsDescription",
    defaultMessage: `
      <p>
        Cliquez sur les options que vous souhaitez ajouter à la liste de priorisation puis
        cliquez sur le bouton "Valider" en bas de la fenêtre. 
      </p>
      <p>
        Les options s'ajouteront dans la liste de priorisation dans l'ordre où vous les 
        sélectionnez. 
      </p>
      <p>
        Une fois la fenêtre validée, vous pourrez ensuite modifier l'ordre de priorité des 
        options depuis la liste qui s'affichera.
      </p>
    `
  },
  maximumOptionsHint: {
    id: "inputs.sortableList.optionsListModal.maximumOptionsHint",
    defaultMessage:
      "{count, plural, one { Maximum 1 option } other { Maximum {count} options }}"
  },
  validate: {
    id: "inputs.sortableList.optionsListModal.validate",
    defaultMessage: "Valider"
  }
});
